import CustomButton from "../../../../components/Button";
import DeleteGif from "../../../../assets/common/DeleteGif.gif";
import CloseIcon from "../../../../assets/closeIcon.svg";
import OneButton from "../../../../components/Button/OneButton";

const DeleteConfirmModale = (props: any) => {
  const { roleInfo, setIsModalOpen, deleteRoleApiCall, title, isUser } = props;

  return (
    <div className="w-full px-4 py-6 sm:px-6 sm:py-8">
      <div className="flex flex-col items-center">
        <div className="flex justify-end"></div>
        <div className="mb-3 flex justify-center">
          <img src={DeleteGif} alt="" className="w-[88px] sm:w-[104px]" />
        </div>

        <div className="mb-6 max-w-[420px]">
          <p className="text-center text-base font-semibold lg:text-lg">
            {`Do you want to delete this ${
              isUser ? roleInfo?.firstName : roleInfo?.roleName || "N/A"
            } ${title} ?`}
          </p>
          {isUser && (
            <p className="mt-2 break-words text-center text-base font-semibold lg:text-lg">{`User Id: ${roleInfo?.userId}`}</p>
          )}
        </div>

        <div className="flex w-full max-w-[420px] flex-col gap-3 sm:flex-row sm:justify-center sm:gap-6">
          <OneButton
            text="YES"
            onClick={() => {
              isUser
                ? deleteRoleApiCall(roleInfo?.userId)
                : deleteRoleApiCall(roleInfo);
            }}
            variant="primary"
            className="w-full"
          />
          <OneButton
            text="CANCEL"
            onClick={() => {
              setIsModalOpen(false);
            }}
            variant="primary"
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};
export default DeleteConfirmModale;
